const COMPLETED_OCCURRENCE_STATUSES = new Set([
  'taken',
  'saved',
  'reserved',
  'missed',
]);

export const getOccurrenceStatusLabel = (status) => {
  const map = {
    available: 'Dostupna',
    unavailable: 'Nedostupna',
    taken: 'Preuzeta',
    saved: 'Sacuvana',
    reserved: 'Rezervisana',
    missed: 'Propustena',
    unassigned: 'Nedodeljeno',
    current: 'Trenutna',
    past: 'Prosla',
  };

  return map[status] || status || '-';
};

export const getOccurrenceSecondaryStatusLabel = (status) => {
  const map = {
    reserved: 'Rezervisana',
  };

  return map[status] || status || '';
};

export const getOccurrenceStatusDisplayLabel = (occurrence) => {
  const primaryLabel = getOccurrenceStatusLabel(occurrence?.status);
  const secondaryLabel = getOccurrenceSecondaryStatusLabel(
    occurrence?.secondaryStatus
  );

  return secondaryLabel ? `${primaryLabel}(R)` : primaryLabel;
};

export const notificationLabels = {
  do_not_contact: 'Ne javljati',
  notification_sent: 'Poslata notifikacija',
  needs_contact: 'Javiti',
  contacted: 'Javljeno',
};

export const getOccurrenceNotificationLabel = (occurrence) =>
  notificationLabels[occurrence?.notificationStatus] ||
  occurrence?.notificationStatus ||
  '-';

export const shouldShowOccurrenceNotificationDate = (occurrence) =>
  ['notification_sent', 'contacted'].includes(
    occurrence?.notificationStatus || ''
  ) && !!occurrence?.notificationDate;

export const sortOccurrences = (occurrences) =>
  [...(Array.isArray(occurrences) ? occurrences : [])].sort((left, right) => {
    const leftSequence = Number(left?.sequenceNumber ?? 0);
    const rightSequence = Number(right?.sequenceNumber ?? 0);

    if (leftSequence && rightSequence && leftSequence !== rightSequence) {
      return leftSequence - rightSequence;
    }

    return (
      new Date(left?.scheduledDate || 0).getTime() -
      new Date(right?.scheduledDate || 0).getTime()
    );
  });

export const getRelevantOccurrence = (occurrences) => {
  const sortedOccurrences = sortOccurrences(occurrences);

  return (
    sortedOccurrences.find(
      (occurrence) => occurrence?.status === 'available'
    ) ||
    sortedOccurrences.find(
      (occurrence) => occurrence?.status === 'unavailable'
    ) ||
    sortedOccurrences.find(
      (occurrence) =>
        !COMPLETED_OCCURRENCE_STATUSES.has(occurrence?.status || '')
    ) ||
    sortedOccurrences[sortedOccurrences.length - 1] ||
    null
  );
};

export const getHighlightedActivity = (therapy, occurrences) => {
  const highlightedType = therapy?.highlightedActivityType;
  const highlightedDate = therapy?.highlightedActivityDate || null;
  const highlightedOccurrenceId = therapy?.highlightedOccurrenceId || null;
  const sortedOccurrences = sortOccurrences(occurrences);

  if (highlightedType === 'renew' && therapy?.renew) {
    return {
      type: 'renew',
      date: highlightedDate || therapy.renew,
      occurrenceId: null,
      occurrence: null,
    };
  }

  if (highlightedType === 'occurrence') {
    // Red tabele (view=table) nema listu aktivnosti, vec samo istaknutu.
    const highlightedOccurrence =
      sortedOccurrences.find(
        (occurrence) => occurrence?._id === highlightedOccurrenceId
      ) ||
      (therapy?.highlightedOccurrence?._id === highlightedOccurrenceId
        ? therapy.highlightedOccurrence
        : null);

    if (highlightedOccurrence) {
      return {
        type: 'occurrence',
        date: highlightedDate || highlightedOccurrence?.scheduledDate || null,
        occurrenceId: highlightedOccurrence._id,
        occurrence: highlightedOccurrence,
      };
    }
  }

  const fallbackOccurrence = getRelevantOccurrence(sortedOccurrences);

  return {
    type: fallbackOccurrence ? 'occurrence' : null,
    date: fallbackOccurrence?.scheduledDate || null,
    occurrenceId: fallbackOccurrence?._id || null,
    occurrence: fallbackOccurrence || null,
  };
};
